import { SubmitHandler, useForm } from "react-hook-form";
import { assingBrand, Brands } from "../../store/employee";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useEffect } from "react";

interface Props {
  isShown: boolean;
  id_user: string;
  employeeBrands: Brands[];
}

type FormValues = {
  id_user: string;
  brands: string[];
};

const AssingBrand = ({ isShown, id_user, employeeBrands }: Props) => {
  const dispatch = useAppDispatch();

  const { register, handleSubmit, setValue } = useForm<FormValues>();
  let startBrands: string[] = [];
  const { allCampaigns } = useAppSelector((state) => state.campaign);

  const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
    dispatch(assingBrand(data));
  };

  useEffect(() => {
    employeeBrands.map((brand) => {
      startBrands.push(brand.id_encrypted);
    });
    setValue("brands", startBrands);
  }, []);

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="c-brands"
        key={id_user}
      >
        <input
          type="text"
          value={id_user}
          {...register("id_user")}
          style={{ display: "none" }}
        />
        {allCampaigns.map((campaing) => (
          <div key={campaing.id_encrypted} className="c-brands__inputs">
            <label
              htmlFor={campaing.id_encrypted + id_user}
              className="c-input__checkbox"
            >
              <img
                src={campaing.pin_logo}
                alt={campaing.name}
                width="20px"
                height="20px"
              />
              {campaing.name}
              <input
                type="checkbox"
                id={campaing.id_encrypted + id_user}
                {...register("brands")}
                value={campaing.id_encrypted}
              />
              <span className="check" />
            </label>
          </div>
        ))}
        <div className="c-brands__buttons">
          <button type="submit" className="c-profile__save-changues">
            Assign brands
          </button>
        </div>
      </form>
    </>
  );
};

export default AssingBrand;
